export const routeMessages = {
  'route.addresses': 'Shipping Addresses',
  'route.adminHome': 'Admin',
  'route.cart': 'Cart',
  'route.categoryList': 'Categories',
  'route.checkout': 'Checkout',
  'route.compare': 'Compare',
  'route.dashboard': 'Dashboard',
  'route.favorites': 'My Favorites',
  'route.forgotPassword': 'Reset Password',
  'route.home': 'Home',
  'route.inventoryList': 'Inventory',
  'route.inventoryWarning': 'Low stock',
  'route.login': 'Sign In',
  'route.messageList': 'Messages',
  'route.notFound': 'Page Not Found',
  'route.notifications': 'Notifications',
  'route.orderDetail': 'Order detail',
  'route.orderList': 'Orders',
  'route.orderSuccess': 'Order Placed',
  'route.productCreate': 'New product',
  'route.productDetail': 'Product detail',
  'route.productEdit': 'Edit product',
  'route.productList': 'Products',
  'route.search': 'Search',
  'route.products': 'Products',
  'route.profile': 'Profile',
  'route.register': 'Sign Up',
  'route.roleList': 'Roles',
  'route.shopDetail': 'Shop',
  'route.shopList': 'Shops',
  'route.userCenter': 'My Account',
  'route.userList': 'Users',
  'route.userOrderDetail': 'Order Detail',
  'route.userOrders': 'My Orders',
};
